export interface RegistrationLink {
  id: string;
  seller_id: string;
  unit_id: string;
  slug: string;
  loan_amount: number;
  installments: number;
  interest_rate: number;
  total_amount: number;
  installment_amount: number;
  installment_dates: string[];
  ruta: number;
  status: string;
  is_active: boolean;
  seller_name: string;
  observations: string;
  created_at: string;
}

export interface Address {
  cep: string;
  logradouro: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  estado: string;
}

export interface Contact {
  nome: string;
  telefone: string;
  relacao: string;
  observacao: string;
  photoFile: File | null;
  photoUrl: string | null;
  conversationFile: File | null;
  conversationUrl: string | null;
}

export interface UploadedDocument {
  category: string;
  label: string;
  file: File | null;
  url: string | null;
  uploading: boolean;
}

export interface RegistrationData {
  // biometric
  selfieUrl: string | null;
  latitude: number | null;
  longitude: number | null;
  locationAccuracy: number | null;
  locationCapturedAt: string | null;
  deviceInfo: string;
  permissionCamera: boolean;
  permissionLocation: boolean;

  // personal
  name: string;
  cpf: string;
  phone: string;
  enderecoResidencial: Address;
  enderecoComercial: Address;
  pixKey: string;
  bank: string;
  serviceEntryTime: string;
  serviceExitTime: string;

  // contacts
  contacts: Contact[];

  // documents
  documents: UploadedDocument[];

  // confirmation
  declarationConfirmed: boolean;
}

export const DOCUMENT_CATEGORIES = [
  { category: 'selfie_com_documento', label: 'Selfie com documento original (RG ou CNH)' },
  { category: 'video_entrando_casa', label: 'Vídeo entrando e saindo de casa falando o nome da vendedora' },
  { category: 'carteira_trabalho', label: 'Carteira de Trabalho exportada do app (hoje)' },
  { category: 'rg_cnh_frente', label: 'Foto RG ou CNH — frente' },
  { category: 'rg_cnh_verso', label: 'Foto RG ou CNH — verso' },
  { category: 'holerite_1', label: '1° Holerite recente' },
  { category: 'holerite_2', label: '2° Holerite recente' },
  { category: 'holerite_3', label: '3° Holerite recente' },
  { category: 'comprovante_endereco', label: 'Comprovante de endereço em nome do cliente' },
  { category: 'foto_local_trabalho', label: 'Foto do local de trabalho' },
  { category: 'foto_frente_residencia', label: 'Foto da frente da residência' },
  { category: 'print_instagram', label: 'Print do perfil do Instagram' },
  { category: 'print_facebook', label: 'Print do perfil do Facebook' },
];

export const emptyAddress: Address = {
  cep: '',
  logradouro: '',
  numero: '',
  complemento: '',
  bairro: '',
  cidade: '',
  estado: '',
};

export const emptyContact = (): Contact => ({
  nome: '',
  telefone: '',
  relacao: '',
  observacao: '',
  photoFile: null,
  photoUrl: null,
  conversationFile: null,
  conversationUrl: null,
});

export function formatCurrency(value: number) {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}
